import React from 'react';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ModalWithConstantPresence } from '@cp/ds/src/components/modalWithConstantPresence';
import { useClientWebRouteProps } from '@cp/entities/clientWebRoutes';
import { useCloseCitySelectionModal, useIsCitySelectionOpen } from 'src/features/location';
import CitySelectionForm from 'src/features/location/ui/citySelectionForm/citySelectionForm';

export const CitySelection: React.FC = () => {
  const onClose = useCloseCitySelectionModal();

  const pageProps = useClientWebRouteProps<ClientWebPage.Catalog>();

  const isOpen = useIsCitySelectionOpen();
  return (
    <ModalWithConstantPresence isActive={isOpen} onClose={onClose}>
      <CitySelectionForm generateCityLinkProps={{ page: ClientWebPage.Catalog, pageProps }} onClose={onClose} pageProps={pageProps} />
    </ModalWithConstantPresence>
  );
};
